import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDownIcon, PlusIcon } from 'lucide-react';
interface BrandDropdownProps {
  brands: Array<{
    id: number;
    name: string;
  }>;
  selectedBrand: {
    id: number;
    name: string;
  } | null;
  setSelectedBrand: (brand: {
    id: number;
    name: string;
  } | null) => void;
}
export const BrandDropdown: React.FC<BrandDropdownProps> = ({
  brands,
  selectedBrand,
  setSelectedBrand
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleBrandSelect = (brand: {
    id: number;
    name: string;
  }) => {
    setSelectedBrand(brand);
    navigate(`/brand/${brand.id}`);
    setIsOpen(false);
  };
  return <div className="relative" ref={dropdownRef} data-id="element-11">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-12">
        {selectedBrand ? selectedBrand.name : <>
            <span className="md:hidden" data-id="element-13">Brand</span>
            <span className="hidden md:inline" data-id="element-14">Select Brand</span>
          </>}
        <ChevronDownIcon className="ml-2 h-4 w-4" data-id="element-15" />
      </button>
      {isOpen && <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-10" data-id="element-16">
          <div className="py-1" data-id="element-17">
            {brands.map(brand => <button key={brand.id} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => handleBrandSelect(brand)} data-id="element-18">
                {brand.name}
              </button>)}
            <div className="border-t border-gray-100 my-1" data-id="element-19"></div>
            <button className="flex items-center w-full text-left px-4 py-2 text-sm text-blue-600 hover:bg-gray-100" data-id="element-20">
              <PlusIcon className="mr-2 h-4 w-4" data-id="element-21" /> Add New Brand
            </button>
          </div>
        </div>}
    </div>;
};